import styled from 'styled-components';

export const SrpcardLayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:100%;
  background-color:${props.theme.colors.blue.bgBlue};
  max-width:120rem;
  margin:0 auto;



`,
);

export const SrpcardInnerLayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:100%;
  flex-direction:row;

`,
);



